var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmIcon2023Original(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1549H6.91176V12.0823L3.44251 8L2 15.1549Z",
    fill: "#157BD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3886 8L6.91211 12.0823V15.1549H11.8311L10.3886 8Z",
    fill: "#00117E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1699 15.1549H17.0817V12.0823L13.6124 8L12.1699 15.1549Z",
    fill: "#157BD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5585 8L17.082 12.0823V15.1549H22.001L20.5585 8Z",
    fill: "#00117E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmIcon2023Original);
export default __webpack_public_path__ + "static/media/mm-icon-2023-original.093bed805a645ed392297128e0776364.svg";
export { ForwardRef as ReactComponent };